import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=22659a38&scoped=true&"
import script from "./Activity.vue?vue&type=script&lang=ts&"
export * from "./Activity.vue?vue&type=script&lang=ts&"
import style0 from "./Activity.vue?vue&type=style&index=0&id=22659a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22659a38",
  null
  
)

export default component.exports